
var id = "sell";
var markup = "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"sell\">\n    <title>销售</title>\n    <defs>\n        <path d=\"M19,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L5,4 C3.9,4 3,4.9 3,6 L3,20 C3,21.1 3.9,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 Z M19,20 L5,20 L5,10 L19,10 L19,20 Z M5,8 L5,6 L19,6 L19,8 L5,8 Z M7,12 L17,12 L17,14 L7,14 L7,12 Z M7,16 L14,16 L14,18 L7,18 L7,16 Z\" id=\"sell_path-1\" />\n    </defs>\n    <g id=\"sell_营销活动-小程序活动管理\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"sell_活动分析\" transform=\"translate(-771.000000, -282.000000)\">\n            <g id=\"sell_区块-活动概要\" transform=\"translate(280.000000, 136.000000)\">\n                <g id=\"sell_区块-查询\" transform=\"translate(32.000000, 145.000000)\">\n                    <g id=\"sell_编组-8\" transform=\"translate(459.000000, 1.000000)\">\n                        <g id=\"sell_Group\" transform=\"translate(0.000000, 0.500000)\">\n                            <mask id=\"sell_mask-2\" fill=\"white\">\n                                <use xlink:href=\"#sell_path-1\" />\n                            </mask>\n                            <g id=\"sell_icon/notification/event_note_24px\" fill-rule=\"nonzero\"></g>\n                            <g mask=\"url(#sell_mask-2)\" fill=\"#000000\" id=\"sell_↳-Color\">\n                                <g>\n                                    <rect id=\"sell_Rectangle\" x=\"0\" y=\"0\" width=\"24\" height=\"24\" />\n                                </g>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
